export type BankIDUrlParams = Record<string, string> & {
  token: string;
  redirect: string;
};

export const BANK_ID_SESSION_KEY = 'mbid.session';
export const setBankIDSession = (params: BankIDUrlParams) => {
  localStorage.setItem(BANK_ID_SESSION_KEY, JSON.stringify(params));
};

export const getBankIdSession = () => {
  const json = localStorage.getItem(BANK_ID_SESSION_KEY);
  if (!json) return {};
  return JSON.parse(json);
};

export const createBankIDUrl = (params: BankIDUrlParams) => {
  setBankIDSession(params);
  return `/bankid`;
};
